export default __webpack_public_path__ + "static/media/tropicanapic1.e633ce61.jpg";